import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ConnectorService } from '../../connector.service';

/**
 * Processus de suppression de compte en 3 étapes :
 * 1. Avertissement + phrase de confirmation à taper
 * 2. Saisie du mot de passe
 * 3. Countdown de 10 secondes avant suppression effective
 */
@Component({
  selector: 'app-delete-account-sheet',
  templateUrl: './delete-account-sheet.component.html',
  styleUrls: ['./delete-account-sheet.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class DeleteAccountSheetComponent {
  step: 'warning' | 'password' | 'countdown' | 'done' | 'error' = 'warning';

  // Étape 1 : phrase de confirmation
  readonly confirmPhrase = 'Je confirme la suppression définitive de mon compte';
  typedPhrase = '';

  // Étape 2 : mot de passe
  password = '';
  passwordError = false;

  // Étape 3 : countdown
  countdown = 10;
  countdownInterval: any;
  cancelled = false;

  constructor(
    private bottomSheetRef: MatBottomSheetRef<DeleteAccountSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { email: string },
    private http: HttpClient,
    private connector: ConnectorService,
  ) {}

  get isPhraseValid(): boolean {
    return this.typedPhrase.trim().toLowerCase() === this.confirmPhrase.toLowerCase();
  }

  goToPassword(): void {
    if (this.isPhraseValid) {
      this.step = 'password';
    }
  }

  goToCountdown(): void {
    if (!this.password) return;
    this.passwordError = false;

    // Vérifier le mot de passe côté serveur en lançant directement la suppression
    // On passe d'abord au countdown, et la suppression se fait à la fin
    this.step = 'countdown';
    this.countdown = 10;
    this.cancelled = false;

    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval);
        if (!this.cancelled) {
          this.executeDelete();
        }
      }
    }, 1000);
  }

  cancelCountdown(): void {
    this.cancelled = true;
    clearInterval(this.countdownInterval);
    this.step = 'warning';
    this.typedPhrase = '';
    this.password = '';
  }

  private executeDelete(): void {
    this.http.post<boolean>(
      environment.backAPI + '/compte/delete-account',
      { password: this.password },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.connector.token(),
        },
      }
    ).subscribe({
      next: (result) => {
        if (result) {
          this.step = 'done';
          setTimeout(() => {
            this.bottomSheetRef.dismiss();
            this.connector.disconnection();
          }, 3000);
        }
      },
      error: (err: HttpErrorResponse) => {
        if (err.status === 401) {
          // Mot de passe incorrect
          this.step = 'password';
          this.passwordError = true;
          this.password = '';
        } else {
          this.step = 'error';
        }
      },
    });
  }

  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
